import { EMPTY_TARIFF_COA_MAPPING_MODEL } from "presentation/model/TariffCoaMapping/TariffCoaMappingModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: TariffCoaMappingProvider,
    useTracked: useTariffCoaMappingTracked
} = createContainer(() => useState(EMPTY_TARIFF_COA_MAPPING_MODEL), {concurrentMode: true});
export { TariffCoaMappingProvider, useTariffCoaMappingTracked };
